import type { ThinkingMode } from '../../../services/aiConfigService';

export const getFormInitialValues = (editing?: ThinkingMode | null) => {
  if (!editing) return { isActive: true };
  return {
    ...editing,
    // 正面词和负面词直接使用数组格式（TagInput 组件需要）
    positiveWords: Array.isArray(editing.positiveWords)
      ? editing.positiveWords
      : editing.positiveWords
      ? JSON.parse(editing.positiveWords as any)
      : [],
    negativeWords: Array.isArray(editing.negativeWords)
      ? editing.negativeWords
      : editing.negativeWords
      ? JSON.parse(editing.negativeWords as any)
      : [],
  };
};
